import Axios from "axios";
import { AuthInjector, RedirectUnauthorize } from "./interceptors";
import { AppRoutesUI } from "../../config/appRoutes";

const token = localStorage.getItem("token");

const AxiosAuth = Axios.create({
  baseURL: process.env.REACT_APP_API,
  headers: {
    authorization: "Bearer " + token,
  },
});

AuthInjector.Add(AxiosAuth);

RedirectUnauthorize.Add(AxiosAuth, AppRoutesUI.Auth.Login.Path(), () => {
  localStorage.clear();
});

export { AxiosAuth };
